import React, { memo, useEffect, useMemo, useState } from 'react';
import { ColorTokens, DividerSizeTokens, InputStateToken, InputTypeToken, } from '@voltmoney/schema';
import { FlatList, View, ScrollView, TouchableOpacity } from 'react-native';
import TextInput from '../textInput/TextInput';
import { Divider } from '../divider/Divider';
/**
 * Primary UI component for user interaction
 */
const SelectionComponent = ({ data, searchString, action, triggerAction, emptyString }) => {
    const [_emptyString, setEmptyString] = useState('');
    const [_searchString, setSearchString] = useState(searchString);
    const [_data, setData] = useState(data);
    const [_filterData, setFilterData] = useState(data);
    const handleSelected = async (value) => {
        action && triggerAction &&
            (await triggerAction({
                ...action,
                payload: {
                    ...action.payload,
                    value: value,
                },
            }));
    };
    const filterData = (searchString) => {
        if (searchString === '') {
            setFilterData(_data);
        }
        const filterData = _data.filter((data) => {
            if (data.value.toLowerCase().startsWith(searchString.toLowerCase())) {
                return data;
            }
        });
        if (filterData.length === 0) {
            setEmptyString(emptyString);
        }
        else {
            setEmptyString('');
        }
        setFilterData(filterData);
    };
    useEffect(() => {
        filterData(_searchString);
    }, [_searchString]);
    const _renderItem = ({ item }) => {
        return (React.createElement(React.Fragment, null,
            React.createElement(TouchableOpacity, { style: {
                    padding: 16,
                }, onPress: () => handleSelected(item.value) }, item.value),
            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk_1 })));
    };
    const renderHeader = () => (React.createElement(ScrollView, null));
    const _child = useMemo(() => (React.createElement(View, { style: {
            flexGrow: 1,
            width: '100%',
        } },
        React.createElement(TextInput, { type: InputTypeToken.DEFAULT, state: InputStateToken.DEFAULT, title: 'Search city', onChangeText: (val) => setSearchString(val) }),
        React.createElement(ScrollView, { style: {
                width: '100%',
                maxHeight: 400,
            } }, (_emptyString !== '') ?
            (React.createElement(React.Fragment, null,
                React.createElement(TouchableOpacity, { style: {
                        padding: 16,
                    } }, _emptyString),
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk_1 }))) :
            (React.createElement(React.Fragment, null,
                React.createElement(FlatList, { data: _filterData, renderItem: _renderItem })))))), [_filterData, _emptyString]);
    return React.createElement(React.Fragment, null, _child);
};
export default memo(SelectionComponent);
export { SelectionComponent };
